import React from 'react'
import { Input, Card } from 'antd'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import { observer } from 'mobx-react-lite'

/**
 * MarkdownEditor component for editing and viewing Markdown content.
 *
 * This component provides a textarea for editing Markdown when `viewOnly` is false.
 * When `viewOnly` is true, it displays the Markdown content rendered as HTML.
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {boolean} props.viewOnly - If true, the editor is in view mode; otherwise, it is in edit mode.
 * @param {string} props.value - The Markdown content to display or edit.
 * @param {function} props.onChange - Function to handle changes to the Markdown content.
 */
const MarkdownEditor = observer(({ viewOnly, value, onChange }) => {
	return (
		<div className="markdown-editor we-markdown-editor">
			{!viewOnly ? (
				<Input.TextArea
					rows={10}
					value={value}
					onChange={onChange}
					disabled={viewOnly}
				/>
			) : (
				<Card>
					<ReactMarkdown>
						{value}
					</ReactMarkdown>
				</Card>
			)}
		</div>
	)
})

MarkdownEditor.propTypes = {
	viewOnly: PropTypes.bool
}

export default MarkdownEditor
